module.exports = __webpack_public_path__ + "static/media/Arya Stark 1.334dca4f.jpg";